export default __webpack_public_path__ + "static/media/280579819_378657990880682_949031553977848604_n.2dc8f145.jpg";